<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Beginnings
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand mankind's place and purpose in God's world.
                        </li>
                        <li>
                            To understand how sin entered God's perfect world, and how it corrupts all people everywhere.
                        </li>
                        <li>
                            To understand the consequences of sin.
                        </li>
                        <li>
                            To understand how we can be rescued from the power of sin and its consequences.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        Genesis 1-11 lays the foundation for an authentically Christian worldview.
                        When we understand that our existence is not a cosmic accident,
                        but the deliberate work of a loving Creator God, life has dignity and purpose.
                        When we understand how sin entered the world we are able to make sense of our present reality,
                        as distressing as it often is. When we see that God has acted to judge sin in the past and
                        promised to finally put an end to it in the future, we are able to live (and die) with hope -
                        the hope of a new heavens and new earth, the home of righteousness. This series deals with five historical events:
                    </p>

                    <ul>
                        <li>
                            the creation of the world
                        </li>
                        <li>
                            the entrance of sin into the world
                        </li>
                        <li>
                            the spread of sin in the world
                        </li>
                        <li>
                            God's judgment on a sinful world
                        </li>
                        <li>
                            God's scattering of people throughout the world
                        </li>
                    </ul>

                    <p>
                        These events need to be understood by children if they are to understand properly the other great historical events -
                        the crucifixion, resurrection and Christ's return to judge the world prior to creating a
                        new heaven and a new earth (Revelation 21:1-4).
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Creation (Genesis 1:1 - 2:3)
                    </p>
                    <p>
                        Lesson 2 - Rebellion (Genesis 2:15 - 3:24)
                    </p>
                    <p>
                        Lesson 3 - Corruption (Genesis 4:1-16)
                    </p>
                    <p>
                        Lesson 4 - Judgment (Genesis 6:5 - 8:22, 9:8-17)
                    </p>
                    <p>
                        Lesson 5 - Confusion (Genesis 11:1-9)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Beginnings",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Beginnings`,
            meta: [
                {
                    name: 'description',
                    content: "To understand mankind's place and purpose in God's world.",
                },
            ],
        };
    },
};
</script>
